module.exports = __webpack_public_path__ + "img/technician_marker.edda23e8.png";